"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _StatusTyp = _interopRequireDefault(require("./StatusTyp"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The HeaderDaten model module.
 * @module model/HeaderDaten
 * @version 1.0.44
 */
var HeaderDaten = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>HeaderDaten</code>.
   * Metadaten zu dem Request
   * @alias module:model/HeaderDaten
   * @param status {module:model/StatusTyp} 
   * @param sessionId {String} Session Id
   */
  function HeaderDaten(status, sessionId) {
    _classCallCheck(this, HeaderDaten);
    HeaderDaten.initialize(this, status, sessionId);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(HeaderDaten, null, [{
    key: "initialize",
    value: function initialize(obj, status, sessionId) {
      obj['status'] = status;
      obj['sessionId'] = sessionId;
    }

    /**
     * Constructs a <code>HeaderDaten</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/HeaderDaten} obj Optional instance to populate.
     * @return {module:model/HeaderDaten} The populated <code>HeaderDaten</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new HeaderDaten();
        if (data.hasOwnProperty('status')) {
          obj['status'] = _StatusTyp.default.constructFromObject(data['status']);
        }
        if (data.hasOwnProperty('version')) {
          obj['version'] = _ApiClient.default.convertToType(data['version'], 'String');
        }
        if (data.hasOwnProperty('build')) {
          obj['build'] = _ApiClient.default.convertToType(data['build'], 'String');
        }
        if (data.hasOwnProperty('sessionId')) {
          obj['sessionId'] = _ApiClient.default.convertToType(data['sessionId'], 'String');
        }
        if (data.hasOwnProperty('authToken')) {
          obj['authToken'] = _ApiClient.default.convertToType(data['authToken'], 'String');
        }
        if (data.hasOwnProperty('errorNr')) {
          obj['errorNr'] = _ApiClient.default.convertToType(data['errorNr'], 'String');
        }
        if (data.hasOwnProperty('mandant')) {
          obj['mandant'] = _ApiClient.default.convertToType(data['mandant'], 'Number');
        }
        if (data.hasOwnProperty('errorMsg')) {
          obj['errorMsg'] = _ApiClient.default.convertToType(data['errorMsg'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>HeaderDaten</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>HeaderDaten</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(HeaderDaten.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['version'] && !(typeof data['version'] === 'string' || data['version'] instanceof String)) {
        throw new Error("Expected the field `version` to be a primitive type in the JSON string but got " + data['version']);
      }
      // ensure the json data is a string
      if (data['build'] && !(typeof data['build'] === 'string' || data['build'] instanceof String)) {
        throw new Error("Expected the field `build` to be a primitive type in the JSON string but got " + data['build']);
      }
      // ensure the json data is a string
      if (data['sessionId'] && !(typeof data['sessionId'] === 'string' || data['sessionId'] instanceof String)) {
        throw new Error("Expected the field `sessionId` to be a primitive type in the JSON string but got " + data['sessionId']);
      }
      // ensure the json data is a string
      if (data['authToken'] && !(typeof data['authToken'] === 'string' || data['authToken'] instanceof String)) {
        throw new Error("Expected the field `authToken` to be a primitive type in the JSON string but got " + data['authToken']);
      }
      // ensure the json data is a string
      if (data['errorNr'] && !(typeof data['errorNr'] === 'string' || data['errorNr'] instanceof String)) {
        throw new Error("Expected the field `errorNr` to be a primitive type in the JSON string but got " + data['errorNr']);
      }
      // ensure the json data is a string
      if (data['errorMsg'] && !(typeof data['errorMsg'] === 'string' || data['errorMsg'] instanceof String)) {
        throw new Error("Expected the field `errorMsg` to be a primitive type in the JSON string but got " + data['errorMsg']);
      }
      return true;
    }
  }]);
}();
HeaderDaten.RequiredProperties = ["status", "sessionId"];

/**
 * @member {module:model/StatusTyp} status
 */
HeaderDaten.prototype['status'] = undefined;

/**
 * Version der App
 * @member {String} version
 */
HeaderDaten.prototype['version'] = undefined;

/**
 * Build Id der Version der App
 * @member {String} build
 */
HeaderDaten.prototype['build'] = undefined;

/**
 * Session Id
 * @member {String} sessionId
 */
HeaderDaten.prototype['sessionId'] = undefined;

/**
 * Authentizitäts Token
 * @member {String} authToken
 */
HeaderDaten.prototype['authToken'] = undefined;

/**
 * Backend Fehlernummer
 * @member {String} errorNr
 */
HeaderDaten.prototype['errorNr'] = undefined;

/**
 * Numer des Mandanten. wird bei VerseNeo übertragen
 * @member {Number} mandant
 */
HeaderDaten.prototype['mandant'] = undefined;

/**
 * Beschreibung des Fehlers
 * @member {String} errorMsg
 */
HeaderDaten.prototype['errorMsg'] = undefined;
var _default = exports.default = HeaderDaten;